<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { isPrerenderEnv } from '@/utils/prerender'

export default {
  name: 'App',
  data() {
    return {
      isRedirecting: false
    }
  },
  mounted() {
    window.history.scrollRestoration = 'manual'
    // 预渲染固定桌面视口，不根据宽度跳转到移动端路由
    if (isPrerenderEnv()) return
    setTimeout(() => {
      this.handleResponsive()
    }, 100)
    window.addEventListener('resize', this.handleResponsive)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResponsive)
  },
  methods: {
    handleResponsive() {
      if (this.isRedirecting || isPrerenderEnv()) return
      
      const isMobile = window.innerWidth < 768
      const currentPath = this.$route.path
      const isMobileRoute = currentPath === '/m' || currentPath.startsWith('/m/')
      
      if (isMobile && !isMobileRoute) {
        this.isRedirecting = true
        const mobilePath = currentPath === '/' ? '/m' : '/m' + currentPath
        this.$router.replace(mobilePath).finally(() => {
          this.isRedirecting = false
        })
      } else if (!isMobile && isMobileRoute) {
        this.isRedirecting = true
        const pcPath = (currentPath === '/m' || currentPath === '/m/')
          ? '/'
          : (currentPath.replace(/^\/m/, '') || '/')
        this.$router.replace(pcPath).finally(() => {
          this.isRedirecting = false
        })
      }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  overflow-x: hidden;
}

a {
  text-decoration: none;
  color: inherit;
}

ul, ol {
  list-style: none;
}

img.v-lazy {
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

img.v-lazy.loaded {
  opacity: 1;
}

/* 全局子菜单样式 - 紧凑化 */
.submenu {
  padding: 0 !important;
  margin: 0 !important;
}

.submenu a,
.submenu .submenu-item {
  display: block !important;
  padding: 8px 18px !important;
  margin: 0 !important;
  line-height: 1.4 !important;
  font-size: 13px !important;
  min-height: auto !important;
  height: auto !important;
}

.submenu a:hover,
.submenu .submenu-item:hover {
  background: rgba(0, 82, 217, 0.08) !important;
  color: #0052D9 !important;
}
</style>